import { useSyncCursorFromPlayback } from '../../hooks/cursor/useSyncCursorFromPlayback';

/**
 * Component that syncs cursor and updates focus when playhead moves outside focus range during seeks.
 * Must be rendered inside a PlaybackProvider to access playback state.
 */
export function SyncCursorFromPlayback() {
  useSyncCursorFromPlayback();
  return null;
}
